import {
  radioSchema,
  radioUI,
} from 'platform/forms-system/src/js/web-component-patterns';

const radioOptions = {
  Personal: {
    label: 'Personal question',
    description:
      'Use this option if you’re a Veteran, family member, caregiver, or survivor. Or if you’re contacting us for a Veteran you know personally.',
  },
  Business: {
    label: 'Business question',
    description:
      'Use this option if you’re asking about a Veteran as part of your job (for example, an SCO, work study site supervisor, or accredited representative).',
  },
};

const getRadioOptionFields = field =>
  Object.entries(radioOptions).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value[field] }),
    {},
  );

export default {
  uiSchema: {
    flowType: radioUI({
      title: 'What type of question do you have?',
      labelHeaderLevel: '3',
      labels: getRadioOptionFields('label'),
      tile: true,
      descriptions: getRadioOptionFields('description'),
      errorMessages: {
        required: 'Select your question type',
      },
    }),
  },
  schema: {
    type: 'object',
    properties: {
      flowType: radioSchema(Object.keys(radioOptions)),
    },
    required: ['flowType'],
  },
};
